import React, { useState } from "react";
import {Container} from 'react-bootstrap';
import Bar1 from '../../images/bar11.png' 
import './Tab.css'
// import Chart from "../Chart/Chart";
import Progress from "../Sidebar/ProgressBar";
import HomeChart from "../Chart/HomeChart";

function Tab3 () {
  const [toggleState, setToggleState] = useState(9);

const toggleTab = (index) =>{
  setToggleState(index)
}
  return (
  <>
  <Container>
 <div className="containerr">
   <div className="block-tab">
     <div className="logo"><h3 className="active-log">Betjig 6</h3>
     <div className="progres-bar">
         <Progress done={82}/>
     </div>
     {/* <div className="bar-tab"><p className="percent">86%</p></div> */}
     </div>
     <div className="list-tab">
       <li className={toggleState === 9 ? "tabs active-tab" : "tabs"} onClick={() => toggleTab(9)}>RFTEST_TX_RSSI</li>
       <li className={toggleState === 10 ? "tabs active-tab" : "tabs"} onClick={() => toggleTab(10)}>RFTEST_TX_RSSI</li>
       <li className={toggleState === 11 ? "tabs active-tab" : "tabs"} onClick={() => toggleTab(11)}>RFTEST_TX_Erroros</li>
       <li className={toggleState === 12 ? "tabs active-tab" : "tabs"} onClick={() => toggleTab(12)}>RFTEST_TX_Erroros</li>
     </div>
   </div>
   <div className="tab-content">
      
     <div className={toggleState === 9 ? "content active-content" : "content"}>
       <div className="tab-title">
         <h2>RFTEST_TX_Erroros</h2>
       </div>
       <div className="tab-chat">
       <div className="home-chart">
         <HomeChart/>
       </div>
       <div className="chat-label">
         <ul className="chat-list">
           <li className="chat-items">
             <div className="chat-point">
               102 / 0
             </div>
             <div className="chat-lab">
               Panels / Hour
             </div>
           </li>
           <li className="chat-items">
             <div className="chat-point">
               55 / 43%
             </div>
             <div className="chat-lab">
               Yield Rate
             </div>
           </li>
           <li className="chat-items">
             <div className="chat-point">
               102 / 0
             </div>
             <div className="chat-lab">
               Panels / Hour
             </div>
           </li>
           <li className="chat-items">
           <div className="chat-point">
               55 / 43%
             </div>
             <div className="chat-lab">
               Yield Rate
             </div>
           </li>
         </ul>
       </div>
       </div>
     </div>
     <div className={toggleState === 10 ? "content active-content" : "content"}>
     <div className="tab-title">
         <h2>Tracer NanoRX/ Top</h2>
       </div>
       <div className="tab-chat">
       <div className="home-chart">
         <HomeChart/>
       </div>
       <div className="chat-label">
         <ul className="chat-list">
           <li className="chat-items">
             <div className="chat-point">
               102 / 0
             </div>
             <div className="chat-lab">
               Panels / Hour
             </div>
           </li>
           <li className="chat-items">
             <div className="chat-point">
               55 / 43%
             </div>
             <div className="chat-lab">
               Yield Rate
             </div>
           </li>
           <li className="chat-items">
             <div className="chat-point">
               102 / 0
             </div>
             <div className="chat-lab">
               Panels / Hour
             </div>
           </li>
           <li className="chat-items">
           <div className="chat-point">
               55 / 43%
             </div>
             <div className="chat-lab">
               Yield Rate
             </div>
           </li>
         </ul>
       </div>
       </div>
     </div>
     <div className={toggleState === 11 ? "content active-content" : "content"}>
     <div className="tab-title">
         <h2>RFTEST_TX_Erroros</h2>
       </div>
       <div className="tab-chat">
       <div className="home-chart">
         <HomeChart/>
       </div>
       <div className="chat-label">
         <ul className="chat-list">
           <li className="chat-items">
             <div className="chat-point">
               102 / 0
             </div>
             <div className="chat-lab">
               Panels / Hour
             </div>
           </li>
           <li className="chat-items">
             <div className="chat-point">
               55 / 43%
             </div>
             <div className="chat-lab">
               Yield Rate
             </div>
           </li>
           <li className="chat-items">
             <div className="chat-point">
               102 / 0
             </div>
             <div className="chat-lab">
               Panels / Hour
             </div>
           </li>
           <li className="chat-items">
           <div className="chat-point">
               55 / 43%
             </div>
             <div className="chat-lab">
               Yield Rate
             </div>
           </li>
         </ul>
       </div>
       </div>
     </div>
     <div className={toggleState === 12 ? "content active-content" : "content"}>
     <div className="tab-title">
         <h2>RFTEST_TX_Erroros</h2>
       </div>
       <div className="tab-chat">
       <div className="home-chart">
         <HomeChart/>
       </div>
       <div className="chat-label">
         <ul className="chat-list">
           <li className="chat-items">
             <div className="chat-point">
               102 / 0
             </div>
             <div className="chat-lab">
               Panels / Hour
             </div>
           </li>
           <li className="chat-items">
             <div className="chat-point">
               55 / 43%
             </div>
             <div className="chat-lab">
               Yield Rate
             </div>
           </li>
           <li className="chat-items">
             <div className="chat-point">
               102 / 0
             </div>
             <div className="chat-lab">
               Panels / Hour
             </div>
           </li>
           <li className="chat-items">
           <div className="chat-point">
               55 / 43%
             </div>
             <div className="chat-lab">
               Yield Rate
             </div>
           </li>
         </ul>
       </div>
       </div>
     </div>
   </div>
 </div>
 </Container>
  </>
  );
}

export default  Tab3
;